<template>
		<v-layout wrap align-center>
			<v-flex>
				<p>{{label}}</p>
				<span>${{ amount | round }}</span>
			</v-flex>
		</v-layout>	
</template>
<script>
import { round } from '@/shared/filters';

export default {
	name: 'customer-expense',
	filters: {
		round,
	},
	props: {
		label: {
			default: '',
			type: String,
		},
		amount: {
			default: 0,
			type: [Number, String],
		},
	},
};
</script>
<style lang="scss" scoped>
	p {
		color: map-get($colors, blue-title);
		font-family: map-get($fonts, regular);
		font-size: 10px;
		margin: 0px;
		text-transform: uppercase;
	}

	span {
		color: map-get($colors, default-skyblue);
		font-family: map-get($fonts, medium);
		font-size: 15px;
	}
</style>




// WEBPACK FOOTER //
// Customer-expense.vue?e0b5b760